module.exports = __webpack_public_path__ + "static/media/logo-adven-eye-removebg-preview.d2556017.png";